import { Box, Container, IconButton, Link, Paper, Typography, useTheme } from '@mui/material';
import React from 'react';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import { FadeInSection } from 'src/components/FadeInSection/FadeInSection';

const Projects: React.FC<{ id: string }> = ({ id }) => {
  const theme = useTheme();
  const projects = [
    {
      name: 'Distributed Logging and Monitoring System',
      websiteUrl: 'https://google.com',
      githubRepoUrl: 'https://github.com',
      description:
        'A system that establishes an ORM connection to a Prisma client in order to communicate logs from microservices',
      technologies: ['Node.js (Express.js)', 'React.js'],
    },
    {
      name: 'Distributed Logging and Monitoring System',
      websiteUrl: 'https://google.com',
      githubRepoUrl: 'https://github.com',
      description:
        'A system that establishes an ORM connection to a Prisma client in order to communicate logs from microservices',
      technologies: ['Node.js (Express.js)', 'React.js'],
    },
    {
      name: 'Distributed Logging and Monitoring System',
      websiteUrl: 'https://google.com',
      githubRepoUrl: 'https://github.com',
      description:
        'A system that establishes an ORM connection to a Prisma client in order to communicate logs from microservices',
      technologies: ['Node.js (Express.js)', 'React.js'],
    },
  ];

  return (
    <Box
      id={id}
      sx={{
        backgroundColor: theme.palette.primary.light,
        boxShadow: `0px 0px 20px ${theme.palette.primary.light}`,
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
          gap: '32px',
          padding: '64px 10vw',
        }}
      >
        <FadeInSection>
          <Typography
            variant='h6'
            sx={{
              color: theme.extendedPalette.accent.main,
            }}
          >
            Projects
          </Typography>
        </FadeInSection>
        {projects.map((project, index) => {
          return (
            <FadeInSection
              key={index}
              delay={(index + 1) * 50}
              fromDirection={index % 2 === 0 ? 'right' : 'left'}
            >
              <Paper
                sx={{
                  width: '80vw',
                  height: '90vw',
                  maxWidth: '275px',
                  maxHeight: '325px',
                  padding: '16px',

                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  textAlign: 'start',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <AccountTreeIcon
                    sx={{ color: theme.extendedPalette.accent.main }}
                    fontSize='large'
                  />
                  <Box sx={{ display: 'flex' }}>
                    <Link
                      href={project.githubRepoUrl}
                      target={'_blank'}
                    >
                      <IconButton>
                        <GitHubIcon fontSize='medium' />
                      </IconButton>
                    </Link>
                    {/* An alernate way of making it seem like a link
                    <IconButton
                      href={project.githubRepoUrl}
                      target={'_blank'}
                    >
                      <GitHubIcon fontSize='medium' />
                    </IconButton> */}
                    <Link
                      href={project.websiteUrl}
                      target={'_blank'}
                    >
                      <IconButton>
                        <OpenInBrowserIcon fontSize='medium' />
                      </IconButton>
                    </Link>
                  </Box>
                </Box>
                <Typography variant='h5'>{project.name}</Typography>
                <Typography variant='body1'>{project.description}</Typography>
                <Typography variant='subtitle1'>
                  {project.technologies.join(', ')}
                </Typography>
              </Paper>
            </FadeInSection>
          );
        })}
      </Container>
    </Box>
  );
};

export default Projects ;
